import type { ApplicationOriginEnvironment } from '@/shared/config';

import { isPlatformHost } from '@/shared/lib';

import type { RegisterPwaServiceWorker } from './register-service-worker';

interface PwaBootstrapEnvironment {
  readonly applicationOrigins?: ApplicationOriginEnvironment;
  readonly initializeInstallPrompt: () => void;
  readonly origin: string;
  readonly registerServiceWorker: RegisterPwaServiceWorker;
}

export const initializePwaBootstrap = ({
  applicationOrigins,
  initializeInstallPrompt,
  origin,
  registerServiceWorker,
}: PwaBootstrapEnvironment): void => {
  if (isPlatformHost(origin, applicationOrigins)) {
    return;
  }

  initializeInstallPrompt();
  void registerServiceWorker();
};
